import { Component } from '@angular/core';

import { pedidoFaturadoParcial } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-faturado-parcial',
    templateUrl: './pedido-status-badge-faturado-parcial.component.html',
    styleUrls: ['./pedido-status-badge-faturado-parcial.component.less']
})
export class PedidoStatusBadgeFaturadoParcialComponent {
    status = pedidoFaturadoParcial;
}
